import { render, staticRenderFns } from "./header-menu.vue?vue&type=template&id=e4b05f3a&"
import script from "./header-menu.vue?vue&type=script&lang=js&"
export * from "./header-menu.vue?vue&type=script&lang=js&"
import style0 from "./header-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports